import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { PatientItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { PatientListItem } from './patient-list-item';

type PatientListProps = {
  loading?: boolean;
  items: PatientItemDataFragment[];
  onClick?: (value: PatientItemDataFragment) => void;
};

export function PatientList({
  loading = false,

  onClick,
  ...props
}: PatientListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <PatientListItem patientItem={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
